<template>
  <div class="page">
    <wgTabs :tabData="tabs" @tabChange="getActive" />
    <br />
    <div class="filter">
      <el-form :model="formQuery" inline size="small">
        <el-form-item label="学生姓名">
          <el-input v-model="formQuery.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单编号" v-if="tabs.active === 2">
          <el-input v-model="formQuery.orderNumber" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="formQuery.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placement="bottom-start"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="methodSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <el-table
        size="small"
        :data="tableData"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#909399',
          'font-size': '14px',
        }"
        :header-row-style="{
          'border-radius': '5px',
          overflow: 'hidden',
        }"
        stripe
      >
        <el-table-column
          v-for="item in getTableTitle"
          :key="item.value"
          :label="item.label"
          :prop="item.value"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.value === 'type'">
              {{ scope.row.type === 0 ? '上课' : '自由发放' }}
            </div>
            <div v-else-if="item.value === 'consumeStarNum'">
              -{{ scope.row.consumeStarNum }}
            </div>
            <div
              v-else-if="item.value === 'orderState'"
              style="display:flex;justify-content:center;align-items:center"
            >
              <i
                :style="{
                  display: 'inline-flex',
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                  marginRight: '5px',
                  backgroundColor:
                    scope.row.orderState === 0
                      ? '#2488ef'
                      : scope.row.orderState === 1
                      ? '#e4393c'
                      : '#17A81C',
                }"
              ></i>
              <span>
                {{
                  scope.row.orderState === 0
                    ? '待兑换'
                    : scope.row.orderState === 1
                    ? '已驳回'
                    : '已完成'
                }}
              </span>
            </div>
            <!-- 操作 -->
            <div v-else-if="item.value === 'operation'">
              <el-button
                type="text"
                size="mini"
                @click="methodLookDetail(scope.row)"
                >查看详情 {{ scope.name }}</el-button
              >
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.currentPage"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="exchangeDialog"
      width=""
      :before-close="methodClose"
    >
      <div class="detail-info" v-if="exchangeRow">
        <div class="goods-img">
          <img :src="exchangeRow.pictureUrl" alt="" />
        </div>
        <div class="goods-detail">
          <div class="detail-title">
            {{ exchangeRow.productName }}
          </div>
          <p>订单编号：{{ exchangeRow.orderNumber }}</p>
          <p>数量：{{ exchangeRow.exchangeNum }}</p>
          <p>
            商品类别：{{
              exchangeRow.productCategory === 0
                ? '伴学精灵'
                : exchangeRow.productCategory === 1
                ? '头像挂件'
                : exchangeRow.productCategory === 2
                ? '实物'
                : '头像'
            }}
          </p>
          <div class="price">
            单价：{{ exchangeRow.starNum }} <span>星币</span>
          </div>
          <div class="choose" v-if="exchangeRow.orderState === 0">
            <el-radio v-model="paramsRadio" label="2">学生已领取商品</el-radio>
            <el-radio v-model="paramsRadio" label="1">驳回</el-radio>
          </div>
          <div class="reject" v-if="exchangeRow.orderState === 0">
            <el-input
              :disabled="paramsRadio !== '1'"
              type="textarea"
              placeholder="请输入驳回原因,30字以内"
              clearable
              show-word-limit
              :maxlength="30"
              resize="none"
              v-model="paramsRejectText"
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="exchangeRow">
        <span class="actual"
          ><strong>实际消耗：{{ exchangeRow.consumeStarNum }}</strong>
          星币</span
        >
        <el-button
          type="primary"
          size="medium"
          @click="methodConfirm"
          v-if="exchangeRow.orderState === 0"
          >确 定</el-button
        >
        <el-button v-else type="primary" size="medium" @click="methodClose"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  api_schoolStarGrantQueryList,
  api_schoolOrderQueryList,
  api_schoolOrderApproval,
} from '@/api/javaApi'

import wgTabs from '../../../components/wgTabs.vue'

// import moment from 'moment'
// let nowTime = moment().format('YYYY-MM-DD HH:mm:ss')

export default {
  name: 'starCoinDetail',
  components: {
    wgTabs,
  },
  props: ['campusData'],
  data: () => ({
    // tab标签所需数据
    tabs: {
      active: 1,
      list: [
        {
          label: '明细列表',
          index: 1,
          hide: false,
        },
        {
          label: '消耗查询',
          index: 2,
          hide: false,
        },
      ],
    },
    // 混合查询条件
    formQuery: {
      eduCampusId: null,
      orderNumber: '',
      name: '',
      time: null,
    },
    // 奖励title
    tableTitleGrant: [
      { label: '学生姓名', value: 'stuName' },
      { label: '场景', value: 'scene' },
      { label: '来源', value: 'sourceName' },
      // { label: '发放方式', value: 'type' },
      { label: '星币数量', value: 'starNum' },
      { label: '时间', value: 'grantTime' },
      { label: '上课老师', value: 'granter' },
      { label: '备注', value: 'remark' },
    ],
    // 消耗title
    tableTitleConsume: [
      { label: '订单号', value: 'orderNumber' },
      { label: '学生姓名', value: 'stuName' },
      { label: '商品名称', value: 'productName' },
      { label: '星币数量', value: 'consumeStarNum' },
      { label: '兑换时间', value: 'exchangeTime' },
      { label: '状态', value: 'orderState' },
      { label: '老师', value: 'auditor' },
      { label: '操作', value: 'operation' },
    ],
    // 混合数据
    tableData: [],
    // 兑换radio 审批状态（1驳回，2通过）
    paramsRadio: '',
    // 驳回理由
    paramsRejectText: '',
    // 兑换弹框
    exchangeDialog: false,
    // 兑换信息载体
    exchangeRow: null,
    page: {
      pageSize: 10,
      currentPage: 1,
      total: 1,
    },
  }),
  computed: {
    getTableTitle() {
      return this.tabs.active === 1
        ? this.tableTitleGrant
        : this.tableTitleConsume
    },
  },
  async created() {
    this.formQuery.eduCampusId = this.campusData[0]
    this.methodSearch()
    for (let i = 0; i < this.tabs.list.length; i++) {
      const item = this.tabs.list[i]
      if (!this.$attrs.methodAuthTabView(item.label)) {
        item.hide = true
      }
    }
  },
  methods: {
    // 获取tab切换index
    getActive(active) {
      this.tabs.active = active
      // Object.assign(this.$data, this.$options.data.call(this));
      this.resetQuery()
      this.methodSearch()
    },
    // 查看详情
    methodLookDetail(row) {
      this.exchangeRow = row
      this.exchangeDialog = true
    },
    // 关闭详情
    methodClose() {
      this.exchangeRow = null
      this.exchangeDialog = false
    },
    methodConfirm() {
      api_schoolOrderApproval({
        id: this.exchangeRow.id,
        userName: this.$store.state.user.userInfo.realName,
        state: this.paramsRadio, // 审批状态（1驳回，2通过）
        productId: this.exchangeRow.productId,
        consumeStarNum: this.exchangeRow.consumeStarNum,
        eduCampusId: this.formQuery.eduCampusId,
        stuId: this.exchangeRow.stuId,
        rejectReason: this.paramsRejectText,
      }).then((res) => {
        console.log(res)
        this.methodSearch()
        this.methodClose()
      })
    },
    // 切换页数
    handleSizeChange(size) {
      this.page.pageSize = size
      this.page.currentPage = 1
      this.methodSearch()
    },
    // 切换页码
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.methodSearch()
    },
    // 查询
    methodSearch() {
      if (this.tabs.active === 1) {
        this.schoolStarGrantQueryList()
      } else {
        this.schoolOrderQueryList()
      }
    },
    // 重置查询参数
    resetQuery() {
      this.page.currentPage = 1
      this.formQuery = {
        ...this.formQuery,
        ...{
          orderNumber: '',
          name: '',
          time: null,
        },
      }
      this.tableData = []
    },
    // 获取奖励列表
    async schoolStarGrantQueryList() {
      let startTime = null,
        endTime = null
      if (this.formQuery.time) {
        startTime =
          this.formQuery.time.length > 0 ? this.formQuery.time[0] : null
        endTime = this.formQuery.time.length > 0 ? this.formQuery.time[1] : null
      }
      api_schoolStarGrantQueryList({
        eduCampusId: this.formQuery.eduCampusId, // 1879
        stuName: this.formQuery.name,
        startTime,
        endTime,
        pageRequest: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
      }).then((res) => {
        console.log(res)
        if (res.content) this.tableData = res.content

        this.tableData.forEach((item) => {
          item.starNum = item.starNum > 0 ? '+' + item.starNum : item.starNum
          item.sourceName = item.sourceName || '--'
        })

        this.page = {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
        }
      })
    },
    // 获取消耗列表
    async schoolOrderQueryList() {
      let startTime = null,
        endTime = null
      if (this.formQuery.time) {
        startTime =
          this.formQuery.time.length > 0 ? this.formQuery.time[0] : null
        endTime = this.formQuery.time.length > 0 ? this.formQuery.time[1] : null
      }
      api_schoolOrderQueryList({
        orderNumber: this.formQuery.orderNumber,
        eduCampusId: this.formQuery.eduCampusId,
        stuName: this.formQuery.name,
        startTime,
        endTime,
        orderStateList: [0, 2],
        pageRequest: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
      }).then((res) => {
        console.log(res)
        if (res.content) this.tableData = res.content
        this.tableData.forEach((data) => {
          data.pictureUrl =
            this.$store.state.resource.picBaseUrl + data.pictureUrl
        })
        this.page = {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px #f0f4f5;
  border-radius: 5px;
  border: 1px solid #f4f5f9;

  .filter {
  }
  .content {
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding: 10px 0;
    }
  }

  .el-dialog {
    .detail-info {
      display: flex;
      padding: 0 25px 15px;
      border-bottom: 1px solid #f5f5f5;
      .goods-img {
        width: 165px;
        height: 165px;
        margin-right: 25px;
        background: #ffffff;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .goods-detail {
        flex: 1;
        padding-top: 10px;
        .detail-title {
          padding-bottom: 10px;
          font-weight: 500;
          font-size: 16px;
          color: #0a1629;
          line-height: 22px;
          letter-spacing: 1px;
        }
        p {
          line-height: 26px;
        }
        .price {
          padding: 15px 0;
          font-weight: 600;
          font-size: 18px;
          color: #1678ff;
          line-height: 25px;
          text-align: left;
          span {
            font-size: 14px;
            font-weight: 400;
          }
        }
        .choose {
          /deep/ .el-radio {
            font-size: 18px;
            .el-radio__input {
              .el-radio__inner {
                width: 18px;
                height: 18px;
              }
            }
            .el-radio__label {
              font-size: 18px;
            }
          }
        }
        .reject {
          padding-top: 10px;
        }
      }
    }
    .dialog-footer {
      .actual {
        margin-right: 38px;
        color: #1678ff;
        line-height: 25px;
        strong {
          font-weight: 600;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
